import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 15l3 -3l-3 -3","key":"svg-0"}],["path",{"d":"M5 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-1"}],["path",{"d":"M7 12h14","key":"svg-2"}]]

const IconArrowRightCircle = createReactComponent('outline', 'arrow-right-circle', 'ArrowRightCircle', __iconNode);

export default IconArrowRightCircle;